export const CUSTOM_FIELD_MANAGE_MODULE_ID = 'custom-field-manage-module';

export const LOAD_CUSTOM_FIELD_MANAGE_MODULE = () =>
  import('@capital-access/custom-fields/manage').then(m => m.CustomFieldsManageModule);
